import React from 'react';
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import DeleteSectionButton from './../DeleteSectionButton';
import LastUpdatedAt from './../LastUpdatedAt';
import {
  TextInput,
  RichTextInput,
  HookFormDirtyCheck,
} from "../../react-hook-form-inputs";


const TeamSchema = Yup.object().shape({
  content: Yup.object()
    .test(
      'has text',
      'Article content is required',
      value => value && value.getCurrentContent().getPlainText().replace(/\s/g, '').length > 0
    ),
  title: Yup.string()
    .required('Summary is required')
    .max(150),
});

export default function TeamForm({
  pitch:{team_section={}}, pitchableType, pitchableId, updatePitchMutation
}) {
  if(team_section === null) team_section = {};

  const defaultValues = {
    title: team_section.title || '',
    content: RichTextInput.createState(team_section.content),
  }
  const methods = useForm({
    resolver: yupResolver(TeamSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: defaultValues
  });

  React.useEffect(() => {
    methods.setValue("title", team_section.title || "");
    methods.setValue("content", RichTextInput.createState(team_section.content || ""));
  }, [methods, team_section]);

  const onSubmit = values => {
    const { title, content } = values
    updatePitchMutation.mutate({
      pitchable_type: pitchableType,
      pitchable_id: pitchableId,
      values: {
        pitch: {
          team_section_attributes: {
            title,
            content: RichTextInput.contentForSave(content),
          }
        }
      }
    })
  }
  return(
    <div id="teamForm">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} className="mt-1">
          <div className="col-xs-12 row">
            <div className="col-lg-7">
              <label className="mb-1">Article content</label>
              <RichTextInput name="content" hideExternalPlugins={false} containerStyle={{ height: "400px"}}/>
            </div>
            <div className="col-lg-5">
              <label className="mb-1">Brief summary</label>
              <TextInput
                name="title"
                placeholder="Brief summary (max 150 chars)"
              />
            </div>
          </div>
          <div className="form-group mt-3">
            <button type="submit"
              className="mx-auto btn btn-outline-dark rounded-0"
              disabled={methods.isSubmitting}
            >
              Save Section
            </button>
            <DeleteSectionButton pitchableType={pitchableType} pitchableId={pitchableId} sectionId={team_section.id} sectionType="team"/>
            <LastUpdatedAt updatedAt={ team_section.updated_at }/>
            <HookFormDirtyCheck />
          </div>
        </form>
      </FormProvider>
    </div>
  );
}
